<template>
  <div>
    <div style="font-style:italic; padding-bottom:8px;">
      {{ message }}
    </div>

    <div class="admin__columns">
      <a class="admin__button" @click="importAllProducts__clicked">Import All Products</a>
    </div>

    <table class="admin__table">
      <tr v-for="(site, index) in potential_sites" :key="index">
        <td>{{index}}</td>
        <td><a :href="`https://${site.domain_url}`" target="_blank">https://{{ site.domain }}</a></td>
        <td>{{ site.handle }}</td>
        <td><router-link :to="`/admin/sites/${site.document_id}/edit`">Edit</router-link></td>
        <td><router-link :to="`/admin/sites/${site.document_id}/products`">Products</router-link></td>
        <td><a @click="importSiteProducts__clicked(site)">Import Products</a></td>
      </tr>
    </table>

  </div>
</template>


<script>

import PotentialShopifySite from '../../../models/PotentialShopifySite'
import ImportProductsTask from '../../../models/ImportProductsTasks'

export default {
  data(){
    return{
      search_value: "",
      potential_sites: [],
      selected_potential_site: null,
      message: "Some Message"
    }
  },
  async mounted(){
    this.potential_sites = await PotentialShopifySite.approvalPage(PotentialShopifySite.ApprovalState.APPROVED);
  },
  computed:{

  },
  methods: {

    async importSiteProducts__clicked(potential_site){
      let task = await ImportProductsTask.startSiteImport(potential_site);

      ImportProductsTask.onDocumentUpdate(task.document_id, document => {
        console.log("task updated", document);
        this.message = document.message;
      });
    },
    async importAllProducts__clicked(event){
      let task = await ImportProductsTask.startAllSitesImport();

      ImportProductsTask.onDocumentUpdate(task.document_id, document => {
        console.log("task updated", document);
        this.message = document.message;
      });
    }

  }
}
</script>
